exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.betting-ball {\n  display: inline-block;\n  width: 9%;\n  height: 7.5vh;\n  line-height: 7.5vh;\n  margin-top: 5px;\n  border: 2px;\n  text-align: center;\n  vertical-align: middle;\n  transition: 0.45s ease;\n  transition-delay: 0.025s;\n  color: #acacad;\n  cursor: pointer;\n  margin-right: 5px;\n  border-radius: 2px;\n  background-color: #404040;\n  box-shadow: 1px 1.7px 7px 0 rgba(0, 0, 0, 0.2);\n}\n.is__active {\n  background-color: #0066ae;\n  color: #fff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07928974","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Ball.vue
// module id = 292
// module chunks = 0